import React, { useState, useEffect } from 'react';

import { string, func } from 'prop-types';
import InputMask from 'react-input-mask';

import Input from '../Input';

function MaskedInput({ mask, value, name, onFocus, onBlur, register, maskplaceholder, ...others }) {
  const [shrink, setShrink] = useState(false);
  const validValue = value?.replace(/\D/g, '');

  useEffect(() => {
    if (register) {
      register(name);
    }
  }, [name, register]);

  useEffect(() => {
    if (validValue) {
      setShrink(true);
    }
  }, [validValue]);

  const handleFocus = () => {
    if (onFocus) {
      onFocus();
    }

    setShrink(true);
  };

  const handleBlur = (ev) => {
    if (onBlur) {
      onBlur(ev);
    }

    if (!validValue) {
      setShrink(false);
    }
  };

  return (
    <Input
      {...others}
      name={name}
      value={value}
      InputLabelProps={{ shrink, ...others.InputLabelProps }}
      onFocus={handleFocus}
      onBlur={handleBlur}
      InputProps={{
        ...others.InputProps,
        inputComponent: InputMask,
        inputProps: {
          ...others.inputProps,
          mask,
          value,
          maskplaceholder,
        },
      }}
    />
  );
}

MaskedInput.defaultProps = {
  mask: '',
  value: '',
};

MaskedInput.propTypes = {
  mask: string,
  value: string,
  onFocus: func,
  onBlur: func,
  name: string,
  register: func,
  maskplaceholder: string,
};

export default MaskedInput;
